import { z } from 'zod/v3'
import { paginationSearchSchema } from '@/lib/pagination'
import { createFileRoute } from '@tanstack/react-router'
import { CustomApplicationPage } from '@/pages/integrations/CustomApplicationPage'

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/integrations_/custom/$applicationId'
)({
  validateSearch: paginationSearchSchema.extend({ tab: z.enum(['overview', 'checks', 'datasets', 'health', 'exceptions']).catch('datasets').optional() }),
  component: CustomApplicationRoute,
  staticData: { pageHeader: { title: 'Custom application', pad: false, scroll: false } },
})

function CustomApplicationRoute() {
  const { workspaceId, applicationId } = Route.useParams()
  const search = Route.useSearch()
  const navigate = Route.useNavigate()
  return <CustomApplicationPage workspaceId={workspaceId} applicationId={applicationId} search={search} onTabChange={(tab) => { void navigate({ search: { tab: tab as NonNullable<typeof search.tab> } }) }} />
}
